import { useState } from "react"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import type { UserTenantFragment } from "@/v2-backoffice-client/user/tenant/__types__/user.tenant.fragment"
import UserTenantManageDialog from "@/v2-backoffice-client/user/tenant/manage/UserTenantManageDialog"

export type UserTenantManageButtonProps = ButtonProps & {
  userId: number
  userName?: string
  existingUserTenants?: UserTenantFragment[]
}

function UserTenantManageButton(props: UserTenantManageButtonProps) {
  const {
    userId,
    userName,
    existingUserTenants = [],
    onClick,
    children,
    ...buttonProps
  } = props

  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        variant="primary"
        size="tiny"
        iconSrc="user-gear"
        iconSize={12}
        onClick={(e) => {
          setIsOpen(true)
          onClick?.(e)
        }}
        {...buttonProps}
      >
        {children ?? "Manage Teams"}
      </Button>

      <UserTenantManageDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        userId={userId}
        userName={userName}
        existingUserTenants={existingUserTenants}
      />
    </>
  )
}

export default UserTenantManageButton
